import React, { useEffect, useState } from "react";
import { Row, Col, Input, Form } from "../../ui/ot";
import dayjs from "dayjs";
import axios from "axios";

const ClassifyStructureForm = ({
    propsForm = null,
    propsValue = null,
    formReloadCount = 0,
    onFormFinish = () => {},
    customFormItems = () => {},
}) => {
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: formValues?.comments * formValues?.number || 0,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        // getPermissionGroupData()
        // getPermissionLevelData()
        // if (editcard) {
        //   setFormValuesOtherThings({
        //     user_id: editcard?.user_id,
        //     permission_time_start:
        //       editcard?.permission_time_start || dayjs().format("YYYY-MM-DD"),
        //     permission_time_end:
        //       editcard?.permission_time_end || dayjs().format("YYYY-MM-DD"),
        //   });
        //   editcard.user_permission_data.forEach((item) => {
        //     setFormValuesOtherThings({
        //       ["user_permission_data." + item?.permission_id]:
        //         item?.permission_level_id,
        //     });
        //   });
        // }
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        //   setFormValuesOtherThings(formValues);
    };
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf("day");
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH");
            let todayDate = dayjs().format("YYYY-MM-DD");
            let currentDate = dayjs(current).format("YYYY-MM-DD");
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour));
            } else {
                return range(0, 24).splice(0, 0);
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm");
            let hour = dayjs().format("HH");
            let todayDate = dayjs().format("YYYY-MM-DD");
            let currentDate = dayjs(current).format("YYYY-MM-DD");
            let currentHour = dayjs(current).format("HH");
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5);
            } else {
                return range(0, 0);
            }
        },
        disabledSeconds: () => {
            return range(0, 0);
        },
    });
    // const {
    //     PermissionGroupData,
    //     getPermissionGroupData
    // } = usePermissionGroup({})

    // const {
    //     PermissionLevelData,
    //     getPermissionLevelData
    // } = usePermissionLevel({})

    useEffect(() => {
        // setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item 
                     rules={[
                        {
                            required: true,
                            message: `此為必填項目`,
                        },
                    ]}
                    label={"名稱"} name="name">
                        <Input></Input>
                    </Form.Item>
                    {customFormItems && customFormItems()}
                </Form>
            </Col>
        </Row>
    );
};

export default ClassifyStructureForm;
